import { LegalPage } from './PublicLayout';

export default function TermsPage() {
    return (
        <LegalPage title="Terms of Service" updated="July 10, 2026" testid="terms-page">
            <p>
                Welcome to Ease My Bill. By accessing or using our website (easemybill.com) or our web application ("Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree, please do not use the Service.
            </p>

            <h2>1. Who we are</h2>
            <p>
                "Ease My Bill", "we", "us" or "our" refers to Ease My Bill, a business based in India providing bill-scanning, expense-tracking, and CA-export software for small and medium businesses.
            </p>

            <h2>2. Eligibility & Accounts</h2>
            <ul>
                <li>You must be at least 18 years old to use the Service.</li>
                <li>You must provide accurate registration information (email, business PAN/GSTIN where applicable).</li>
                <li>You are responsible for keeping your login credentials confidential. Notify us immediately at support@easemybill.com if you suspect unauthorized use.</li>
            </ul>

            <h2>3. Subscription & Billing</h2>
            <ul>
                <li>Ease My Bill Pro is offered on a monthly subscription basis at ₹399/month (inclusive of applicable taxes) with a 1-month free trial for new users.</li>
                <li>Your subscription auto-renews at the end of each billing period unless cancelled. You can cancel anytime from your account settings; access continues until the end of the current period.</li>
                <li>Payments are processed by Razorpay Software Private Limited. We never see or store your card details.</li>
                <li>The Service includes a monthly usage limit of 150 bill scans. Additional scans can be purchased as top-up packs (25 for ₹100 or 100 for ₹300) or by contacting support for a custom plan.</li>
            </ul>

            <h2>4. Refunds</h2>
            <p>
                Refunds are governed by our <a href="/refund">Refund Policy</a>. In summary, we offer a 7-day money-back guarantee on your first paid month if you are not satisfied.
            </p>

            <h2>5. Acceptable Use</h2>
            <p>You agree not to:</p>
            <ul>
                <li>Upload content that is illegal, fraudulent, or violates any third party's rights.</li>
                <li>Upload bills or documents you do not have the right to process.</li>
                <li>Attempt to reverse-engineer, decompile, or circumvent security features of the Service.</li>
                <li>Use the Service to fabricate or edit financial documents with intent to defraud any party, including tax authorities.</li>
                <li>Abuse our OCR, WhatsApp, or export endpoints with automated scripts beyond documented rate limits.</li>
            </ul>

            <h2>6. Your Content & Data</h2>
            <ul>
                <li>You retain full ownership of the bills, invoices, and financial data you upload.</li>
                <li>You grant us a limited, non-exclusive license to store, process, and display your data solely to operate and improve the Service for you.</li>
                <li>We process your data in accordance with our <a href="/privacy">Privacy Policy</a>.</li>
            </ul>

            <h2>7. Accuracy Disclaimer</h2>
            <p>
                Ease My Bill uses AI-based OCR which is highly accurate but not infallible. You are responsible for verifying extracted data before using it for tax filing, accounting, or any legal purpose. We do not certify bills as authentic and do not provide tax or legal advice.
            </p>

            <h2>8. Service Availability</h2>
            <p>
                We aim for 99% monthly uptime but do not guarantee uninterrupted availability. Planned maintenance will be notified where possible. We are not liable for losses arising from service downtime, third-party failures (payment gateways, OCR providers, cloud infrastructure), or force majeure events.
            </p>

            <h2>9. Intellectual Property</h2>
            <p>
                The Service, including its design, source code, trademarks and logos, is our exclusive property. You may not copy, modify, or create derivative works without our written permission.
            </p>

            <h2>10. Termination</h2>
            <p>
                We may suspend or terminate your account for material breach of these Terms, illegal use of the Service, or extended non-payment. You may terminate at any time from Settings; residual access continues until your billing period ends.
            </p>

            <h2>11. Limitation of Liability</h2>
            <p>
                To the maximum extent permitted by law, our total liability for any claim relating to the Service will not exceed the fees you paid us in the 3 months preceding the claim. We are not liable for indirect, incidental, consequential or punitive damages.
            </p>

            <h2>12. Governing Law</h2>
            <p>
                These Terms are governed by the laws of India. Disputes will be subject to the exclusive jurisdiction of courts in India.
            </p>

            <h2>13. Changes to these Terms</h2>
            <p>
                We may update these Terms from time to time. Material changes will be notified by email or in-app banner at least 14 days before they take effect.
            </p>

            <h2>14. Contact</h2>
            <p>
                Questions? Reach out at <a href="mailto:support@easemybill.com">support@easemybill.com</a>.
            </p>
        </LegalPage>
    );
}
